$(document).ready(function() {
    $('#contacf-form-v5').submit(function(e) {
        e.preventDefault();
       
        const formFields = $('#contacf-form-v5').serializeArray();
        const selectFields = $('#contacf-form-v5 select');

        let isValid = true;

        $('#contacf-form-v5 .input-container').removeClass('error');

        formFields.map( field => {
            switch (field.name) {
                case 'name':
                    if (!validateNameV5(field.value)) {
                        $('#contacf-form-v5 [name="name"]').parent().addClass('error');
                        isValid = false;
                    }
                    break;

                case 'email':
                    if (!validateEmailV5(field.value)) {
                        $('#contacf-form-v5 [name="email"]').parent().addClass('error');
                        isValid = false;
                    }
                    break;

                case 'description':
                    if (!field.value) {
                        $('#contacf-form-v5 [name="description"]').parent().addClass('error');
                        isValid = false;
                    }
                    break;

                case 'phone': 
                    if (!validatePhoneV5(field.value)) {
                        $('#contacf-form-v5 [name="phone"]').parent().addClass('error'); 
                        isValid = false;
                    }
                    break;

                case '00N8c00000dsXIS':
                    if (!validateDocumentV5(field.value)) {
                        $('#contacf-form-v5 [name="00N8c00000dsXIS"]').parent().addClass('error'); 
                        isValid = false;
                    }
                    break;
                
                default:
                    break;
            }
        });

        jQuery.each( selectFields, function( i, field ) {
            switch (field.name) {
                case 'recordType':
                    if (!field.value) {
                        $('#contacf-form-v5 [name="recordType"]').parent().addClass('error');
                        isValid = false;
                    }
                    break;

                case 'subject':
                    if (!field.value) {
                        $('#contacf-form-v5 [name="subject"]').parent().addClass('error');
                        isValid = false;
                    }
                    break;
                
                case '00N8B000001ef99':
                    if (!field.value) {
                        $('#contacf-form-v5 [name="00N8B000001ef99"]').parent().addClass('error');
                        isValid = false;
                    }
                    break;
               
                default:
                    break;
            }
            
        });

        if (isValid) {
            const _self = this;
        
            const isStaging =
                window.location.href.indexOf("nihlo-cosmetics-dev.myshopify.com") > -1;
            const baseUrl = isStaging
                ? "https://qa.apps.nihlo.com.co/"
                : "https://apps.nihlo.com.co/";
            const apiKey = "Api-Key 2WraagS5.pf9Fzsl9HCXc9GdCAtq4KgXi6Htgaf1i";

            var formData = {
                'request_type': $("#recordType option:selected").text(),
                'name_or_company': $('#name').val(),
                'id_number': $('#00N8c00000dsXIS').val(),
                'email': $('#email').val(),
                'phone': $('#phone').val(),
                'subject': $('#subject').val(),
                'company': $('#company').val(),
                'description': $('#description').val(),
                'invoice_order_number': $('#00N8c00000dsXIT').val() ? $('#00N8c00000dsXIT').val() : '0',
                'habeas_data': $('#00N8c00000gFMvO').val() == "SI" ? true : false,
            };

            $.ajax({
                url: baseUrl + 'api/client/v2/contact-us/',
                type: 'POST',
                data: JSON.stringify(formData),
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: apiKey
                },
                success: function(response) {
                    console.log(response);
                    // successMessage(_self);
                },
                error: function(xhr, status, error) {
                    console.error('Error:', error);
                }
            });

            successMessage(_self);
        }
        
    });
});

function validateEmailV5(email) {
    const reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return reg.test(String(email).toLowerCase());
}

function validateNameV5(name) {
    const reg = /^[A-Za-z\s]+$/;
    return reg.test(String(name).toLowerCase());
}

function validatePhoneV5(phone) {
    const reg = /^\d{7,}$/;
    return reg.test(String(phone).toLowerCase());
}

function validateDocumentV5(document) {
    const reg = /^[0-9\s]+$/;
    return reg.test(String(document).toLowerCase());
}

function successMessage(_self) {
    Swal.fire({
        icon: "success",
        text: "Su solicitud ha sido recibida de forma exitosa; próximamente le estaremos enviando a su correo electrónico el número de radicado y demás información.",
    });

    setTimeout(() => {
        _self.submit();
    }, 3000);
}